import React, { useRef, useEffect } from 'react';
import {
    Input
} from "reactstrap";
import Tagify from '@yaireo/tagify';
import '@yaireo/tagify/dist/tagify.css';

function MyTagInput({ value = [], onChange, valid, invalid }) {
  const inputRef = useRef();
  const tagifyRef = useRef();

  useEffect(() => {
    tagifyRef.current = new Tagify(inputRef.current, {
      whitelist: [],
      maxTags: 10,
      placeholder: 'Add subtypes',
    });

    tagifyRef.current.on('change', e => {
      const tags = e.detail.tagify.value;
      const values = tags.map(tag => tag.value);
      onChange(values);
    });

    tagifyRef.current.loadOriginalValues(value);

    return () => {
      tagifyRef.current.destroy();
    };
  }, []);

  useEffect(() => {
    if (tagifyRef.current) {
      tagifyRef.current.loadOriginalValues(value);
    }
  }, [value]);

  let className = 'form-control';
  if (valid) className += ' is-valid';
  if (invalid) className += ' is-invalid';

  return (
    <input
      ref={inputRef}
      style={{ width: '100%' }}
      className={className}
    />
  );
}

export default MyTagInput;